import * as React from 'react';
import { FormGroup, Label } from './styles/common';

export function FormInputPrice({
  label, onChange, name, error, valid, type = 'text', placeholder, value, suffix = '€', allowDecimals = false,
  // Optional note under the field. Marks a value filled in from an uploaded document,
  // so the user knows to check it rather than assume we got it right.
  // See FormInputText: marks a value that came from an uploaded document.
  hint,
}) {
  const inputRef = React.useRef(null);

  // Remove all non-numeric characters except commas
  // check if value is empty or null or number
  if (value == null) {
    value = '';
  } else if (typeof value === 'number') {
    value = String(value);
  }

  let formattedValue;
  if (allowDecimals) {
    // Decimal-capable fields (e.g. percent rates) keep the raw, unformatted
    // string: toLocaleString() would both group thousands (wrong for a rate)
    // and mangle a partially-typed decimal (e.g. drop a trailing comma).
    formattedValue = value ? `${value} ${suffix}` : '';
  } else {
    const numericValue = value.replace(/[^\d,]/g, '');
    formattedValue = numericValue
      ? `${Number(numericValue.replace(/,/g, '')).toLocaleString()} ${suffix}`
      : '';
  }

  const handleInputChange = (e) => {
    let rawValue;
    if (allowDecimals) {
      // Allow digits plus a single comma decimal separator; drop any
      // additional commas the user attempts to type.
      const cleaned = e.target.value.replace(/[^\d,]/g, '');
      const firstComma = cleaned.indexOf(',');
      rawValue = firstComma === -1
        ? cleaned
        : cleaned.slice(0, firstComma + 1) + cleaned.slice(firstComma + 1).replace(/,/g, '');
    } else {
      rawValue = e.target.value.replace(/[^\d]/g, ''); // Remove all non-numeric characters
    }
    onChange(rawValue); // Pass only the numeric part without formatting
  };

  const handleKeyUp = (e) => {
    const { selectionStart } = e.target;

    if (inputRef.current) {
      const newCursorPos = Math.min(selectionStart, inputRef.current.value.length - 2); // Keep cursor inside valid range
      setTimeout(() => {
        inputRef.current.setSelectionRange(newCursorPos, newCursorPos);
      }, 0); // Wait for DOM updates to complete
    }
  };

  return (
    <FormGroup>
      {label !== undefined && (
        <Label>
          {label}
          {' '}
          (
          {suffix}
          )
        </Label>
      )}
      <input
        ref={inputRef}
        placeholder={placeholder}
        className={`form-control text-center ${error ? 'is-invalid' : ''} ${valid ? 'is-valid' : ''
        }`}
        type={type}
        value={formattedValue}
        name={name}
        onChange={handleInputChange}
        onKeyUp={handleKeyUp}
      />
      <div className="invalid-feedback">{error}</div>
      {hint && <p className="form-input-hint">{hint}</p>}
    </FormGroup>
  );
}
